
import { DETAIL_PROPERTY, FETCH_LIST_PROPERTY, UPDATE_PROPERTY } from '../types';
export const listPropertyReducer = (
  state = { isLoading: true, data: {results: [], count:0} },
  action: { type: any; payload: any }
) => {
  switch (action.type) {
    case FETCH_LIST_PROPERTY:
      return {
        isLoading: false,
        data: action.payload,
      };
    default:
      return state;
  }
};

export const updatePropertyReducer = (
  state = { isLoading: true, data: {} },
  action: { type: any; payload: any }
) => {
  switch (action.type) {
    case UPDATE_PROPERTY:
      return {
        isLoading: false,
        data: action.payload,
      };
    default:
      return state;
  }
};

export const detailPropertyReducer = (
  state = { isLoading: true, data: {} },
  action
) => {
  switch (action.type) {
    case DETAIL_PROPERTY:
      return {
        isLoading: false,
        data: action.payload,
        filteredData: action.payload,
      };

    default:
      return state;
  }
};